'use client';

import React from 'react';

import Heading from '@/components/ui/Heading/Heading';
import RichText from '@/components/ui/RichText/RichText';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface SectionGridProps {
  heading?: any;
  description?: any;
  children: React.ReactNode;
  backgroundColor?: string;
  gridClassName?: string;
  spacingClassName?: string;
  gapClassName?: string;
}

const isString = (value: any) => typeof value === 'string';

const SectionGrid: React.FC<SectionGridProps> = ({
  heading,
  description,
  children,
  backgroundColor = 'bg-transparent',
  gridClassName = 'grid-cols-1 md:grid-cols-2',
  spacingClassName = 'py-8',
  gapClassName = 'gap-8',
}) => {
  const { ref, sectionClasses, childClasses, getChildStyle } =
    useScrollAnimation();

  return (
    <section
      ref={ref}
      id={`section-grid-${heading}`}
      className={`${spacingClassName} relative ${backgroundColor} ${sectionClasses}`}
    >
      <div className="content-wrapper">
        <div className="mx-auto">
          {(heading || description) && (
            <div
              className={`mb-8 space-y-4 text-center ${childClasses()}`}
              style={getChildStyle(200)}
            >
              {heading &&
                (isString(heading) ? (
                  <RichText
                    styles={{
                      p: 'text-center text-royal-500 text-4xl font-bold',
                    }}
                  >
                    {heading}
                  </RichText>
                ) : (
                  <Heading
                    content={heading}
                    className="text-royal-500 text-center"
                  />
                ))}

              {description &&
                (isString(description) ? (
                  <RichText
                    styles={{
                      p: 'mx-auto max-w-3xl text-center text-text-body-dark leading-relaxed',
                    }}
                  >
                    {description}
                  </RichText>
                ) : (
                  <RichText styles={{ p: 'text-center max-w-3xl mx-auto' }}>
                    {description}
                  </RichText>
                ))}
            </div>
          )}

          <div
            className={`${gapClassName} ${gridClassName} ${childClasses()}`}
            style={getChildStyle(400)}
          >
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionGrid;
